import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取下单送券配置列表
 * */
export const getOrderFreeCouponListApi = (params:object) => $http.get('/admin/brands/get_coupon_activelist', params)

/**
 * 检查下单送券是否可用（不可重复配置）
 * */
export const checkCouponValidApi = (coupon_id:string) => $http.get('/admin/brands/check_coupon_id', { coupon_id })

/**
 * 保存下单送券配置
 * */
export const saveOrderFreeCouponApi = (data:object) => $http.post('/admin/brands/sendcoupon', { ...data })

/**
 * 获取广告列表
 * */
export const getAdListApi = (params:object) => $http.get('/admin/user/get_home_resources', params)

/**
 * 保存广告配置
 * */
export const saveAdApi = (data:object) => $http.post('/admin/user/save_home_resource', { ...data })

/**
 * 删除广告配置
 * */
export const delAdApi = (id:any) => $http.post('/admin/user/del_home_resource', { id })

/**
 * 获取蛋糕页ICON列表
 * */
export const getCakeSecondIconListApi = () => $http.get('/cake_api/cakeIconList')

/**
 * 保存蛋糕页ICON
 * */
export const saveCakeSecondIconApi = (data:object) => $http.post('/cake_api/cakeIconSave', data)

/**
 * 删除蛋糕页ICON
 * */
export const delCakeSecondIconApi = (id:number) => $http.post('/cake_api/cakeIconDel', { id })

/**
 * 根据蛋糕页ICON获取商品列表
 * */
export const getCakeSecondIconProductListApi = (params: object) => $http.get('/cake_api/getLabelProducts', params)

/**
 * 更新蛋糕页ICON商品排序值
 * */
export const updateCakeSecondIconProductSortApi = (icon_id, product_id, sort) => $http.get('/cake_api/setLabelProductsSort', { icon_id, product_id, sort })

/**
 * 获取蛋糕页商品列表推荐分类标签
 * */
export const getCakeSecondRecommendLabelListApi = () => $http.get('/cake_api/cakeMarketList')

/**
 * 保存蛋糕页商品列表推荐分类标签
 * */
export const saveCakeSecondRecommendLabelApi = (data:object) => $http.post('/cake_api/cakeMarketAdd', {label_data: data})

/**
 * 删除蛋糕页商品列表推荐分类标签
 * */
export const delCakeSecondRecommendLabelApi = (id:number) => $http.post('/cake_api/cakeMarketDel', { id })

/****************************** 官方立减 - begin ******************************/
export const getFinalPayListApi = (params:object={}) => $http.get('/cake_api/fullReductionList', params)
export const saveFinalPayApi = (data:object) => $http.post('/cake_api/fullReductionSave', data)
export const delFinalPayApi = (activity_id:number) => $http.post('/cake_api/fullReductionclose', { activity_id })
export const getFinalPayShieldInfoApi = (id:number) => $http.get('/cake_api/getFullConfig', { id })
export const saveFinalPayShieldApi = (data:object) => $http.post('/cake_api/saveFullConfig', data)
/****************************** 官方立减 - end ******************************/

// 热搜配置页面
export const getSearchList = (params: object = {}) => $http.get('/admin/user/get_search_list', params)
export const updateSearchConfigApi = (data: object) => $http.post('/admin/user/add_search', data)
export const toggleStatusApi = (data: object) => $http.post('/admin/user/oper_search', data)
// 更新热搜配置排序值
export const updateSortApi = (data: object) => $http.post('/admin/user/search_sort', data)
// 上传热搜配置图片
export const importSearchImgApi = (data: object) => $http.post('/admin/user/import_search_img', data)

/****************************** 优惠券 - begin ******************************/
/**
 * 获取优惠券包列表
 * @param name          （选填）    券包名称
 * @param coupon_id     （选填）    券包ID
 * @param memo          （选填）    备注
 * @param type          （选填）    券包类型：1-品牌礼券，2-代金券，3-充值卡
 * @param status        （选填）    券包状态：0-未发布，1-已发布
 * @param sale_channel  （选填）    销售渠道
 * @param created_at    （选填）    券包创建日期
 * @param amount        （选填）    券包面额
**/
export const getCouponPackageListApi = (params:object={}) => $http.get('/opsapi/couponIndex', params)

/**
 * 添加/编辑优惠券包
 * @param id            （选填）    券包ID
 * @param coupon_id     （选填）    券包ID
 * @param memo          （选填）    备注
 * @param type          （选填）    券包类型：1-品牌礼券，2-代金券，3-充值卡
 * @param status        （选填）    券包状态：0-未发布，1-已发布
 * @param sale_channel  （选填）    销售渠道
 * @param created_at    （选填）    券包创建日期
 * @param amount        （选填）    券包面额
**/
export const saveCouponPackageApi = (data:object) => $http.post('/opsapi/couponSave', data)

/**
 * 获取优惠券包详情
 * @param id            （必填）    券包ID
**/
export const getCouponPackageDetailApi = (id:any) => $http.post('/opsapi/couponDetail', { id })

/**
 * 获取指定券包的线上券列表数据
 * @param coupon_id     （选填）    券ID
 * @param coupon_no     （选填）    券号
 * @param id            （选填）    券包ID
 * @param status        （选填）    券状态：0-已激活，1-已绑定，-1-已作废，-4-待激活，-5-未激活
 * @param valid_from    （选填）    券有效期自
 * @param valid_to      （选填）    券有效期至
**/
export const getCouponListApi = (params:object) => $http.get('/opsapi/getUserCouponsList', params)

/**
 * 为指定用户绑券
 * @param user_coupon_id    （选填）    券包ID
 * @param username          （选填）    用户名
 * @param msg               （选填）    绑定备注
**/
export const bindUserCouponApi = (data:object) => $http.post('/opsapi/couponsBind', data)

/**
 * 为指定用户解绑券
 * @param coupon_id     （选填）    券包D
 * @param bind_user_id  （选填）    用户ID
 * @param msg           （选填）    解绑备注
**/
export const unbindUserCouponApi = (data:object) => $http.post('/opsapi/couponsUnbind', data)

/**
 * 批量为指定用户绑券
 * @param coupon_id     （选填）    券包ID
 * @param userids       （选填）    用户ID
 * @param msg           （选填）    绑定备注
**/
export const batchBindUserCouponApi = (data:object) => $http.post('/psapi/batchBindNew', data)

/**
 * 生成礼券
 * @param id            （必填）    券包ID
**/
export const genCouponApi = (id: number) => $http.get('/opsapi/CouponsGen', { id })

/**
 * 更新礼券状态
 * @param user_coupon_id    （必填）    券ID
**/
export const updateCouponStatusApi = (user_coupon_id: any) => $http.get('/opsapi/unsetCoupon', { user_coupon_id })

/**
 * 将礼券状态改为已使用
 * @param user_coupon_id    （必填）    券ID
 * @param msg               （必填）    备注
**/
export const changeCouponStatusToUsedApi = (user_coupon_id: string | number, msg: string) => $http.post('/opsapi/unsetCoupons', { user_coupon_id, msg })

/**
 * 根据券码查询礼券核销状态
 * @param coupon_no    （必填）    券号
**/
export const getCouponCheckStatusApi = (coupon_no: any) => $http.get('/opsapi/checkCouponNo', { coupon_no })

/**
 * 根据券包ID获取是否可调拨入总库
 * @param ds_coupon_id    （必填）    关联券包ID
**/
export const getCouponTransferStatusApi = (ds_coupon_id: any) => $http.get('/opsapi/getOfflineCouponLists', { ds_coupon_id })

/**
 * 根据券包ID获取是否可调拨入总库
 * @param coupon_id     （必填）    券包ID
 * @param ds_coupon_id  （必填）    关联券包ID
 * @param num           （必填）    数量
 * @param note          （选填）    备注
**/
export const transferApi = (data: object) => $http.post('/opsapi/sendCouponItemBacks', data)
/****************************** 优惠券 - end ******************************/

/****************************** 配送规则 - begin ******************************/
// 商品id绑定配送规则  item_id：商品id或者品牌id item_type：product代表商品，brand代表品牌 distribution_rule_ids：配送规则id逗号分隔
export const bindDistributionRuleApi = (data: object) => $http.post('/admin/brands/bind_distribution_rule', data)

// 获取商品关联配送规则 item_id：商品id或者品牌id item_type：product代表商品，brand代表品牌
export const getProductDistributionRulesApi = (params: object) => $http.get('/admin/brands/get_product_distribution_rules', params)
/****************************** 配送规则 - end ******************************/

/****************************** 支付成功页推荐商品 - begin ******************************/

// 获取支付成功商品列表
export const getPayProductListApi = (params: object) => $http.get('/sys/admin/listPayProduct', params)

// 添加商品 product_id： 多个逗号隔开的字符串
export const addPayProductApi = (data: object) => $http.post('/sys/admin/addPayProduct', data)

// 删除商品 id 商品id
export const deletePayProductApi = (data: object) => $http.post('/sys/admin/deletePayProduct', data)
// 成功页商品推荐修改排序值接口 id sort_num：排序值
export const doPayProductRunkApi = (data: object) => $http.post('/sys/admin/doPayProductRunk', data)

/****************************** 支付成功页推荐商品 - end ******************************/
